import { render, staticRenderFns } from "./TerminalAnswerScreen.vue?vue&type=template&id=a1ecfb0e&scoped=true&"
import script from "./TerminalAnswerScreen.vue?vue&type=script&lang=js&"
export * from "./TerminalAnswerScreen.vue?vue&type=script&lang=js&"
import style0 from "./TerminalAnswerScreen.vue?vue&type=style&index=0&id=a1ecfb0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ecfb0e",
  null
  
)

export default component.exports